// extracted by mini-css-extract-plugin
export default {"loader":"ConversationList_loader__FWBmy","no-chats-message":"ConversationList_no-chats-message__FPuaH"};